import { Mapping } from 'src/containers/ProjectDiagram/types/data';
import { LinkData, NodeData } from 'src/containers/ProjectDiagram/types/model';
import {
  isMapping,
  isModelConceptRelationship,
} from 'src/containers/ProjectDiagram/utils/data';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 *  Migration to add extra fields to model `draftData`
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v30 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v30Projects(prevState.projects);
  }

  return nextState;
};

const v30Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    if (!project.diagram.model.modelData.draftData) {
      projectsById[projectId] = project;
      return;
    }

    const prevNodeDataMap: Record<string, NodeData> = {};
    project.diagram.model.nodeDataArray.forEach((data) => {
      prevNodeDataMap[data.key] = data;
    });

    const prevLinkDataMap: Record<string, LinkData> = {};
    const prevRelationshipValues: Record<string, boolean> = {};
    const prevMappingDataMap: Record<string, Mapping> = {};
    project.diagram.model.linkDataArray.forEach((data) => {
      prevLinkDataMap[data.key] = data;
      if (isModelConceptRelationship(data)) {
        prevRelationshipValues[data.value] = true;
      } else if (isMapping(data)) {
        prevMappingDataMap[data.value] = data;
      }
    });

    projectsById[projectId] = {
      ...project,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          modelData: {
            ...project.diagram.model.modelData,
            draftData: {
              ...project.diagram.model.modelData.draftData,
              prevNodeDataMap,
              prevLinkDataMap,
              prevRelationshipValues,
              prevMappingDataMap,
            },
          },
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
